import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M18.333 1.88a3.777 3.777 0 0 1 2.69 1.1l.16.171a3.774 3.774 0 0 1-.189 5.188L8.94 20.389a.75.75 0 0 1-.34.196L2.815 22.1a.75.75 0 0 1-.915-.916L3.416 15.4a.75.75 0 0 1 .195-.34l-.056.063a.744.744 0 0 1 .038-.044l.018-.019L15.66 3.016a3.777 3.777 0 0 1 2.673-1.135zM4.646 16.623l-.97 3.702 3.706-.971-.82-1.913-1.916-.818zM16.244 8.82l-8.222 8.219.644 1.503 8.651-8.65-1.073-1.072zM14.11 6.686l-8.653 8.65 1.504.643 8.223-8.22-1.074-1.073zm4.27 2.147l.68-.68-3.209-3.207-.68.68 1.6 1.599.005.004 1.603 1.604zm-.035-5.452c-.52.003-1.02.184-1.424.513l3.192 3.19a2.274 2.274 0 0 0-.149-3.042l-.149-.135a2.277 2.277 0 0 0-1.47-.526z' />
  </svg>
);
